import { Inventory } from '@/root/shared-types'

type SailInventorySummary = {
  bicycleQty?: number
  /** Free car-deck space. f-edge gives it as a number of vehicles of the tenant's default vehicle type. */
  carDeckQty?: number
  passengerQty?: number
  residentQty?: number
}

type GetSailInventorySummaryParams = {
  inventory: Inventory
  sailRefId: string
}

export const getSailInventorySummary = ({
  sailRefId,
  inventory,
}: GetSailInventorySummaryParams): SailInventorySummary => {
  const sailKey = String(sailRefId)

  const passengerDeck = inventory.passengerDecksAvailabilities[sailKey]
  const carDeck = inventory.carDecksAvailabilities[sailKey]

  const passengerInventory = passengerDeck?.availableInventoryClasses.find((item) => item.inventoryClass === 'DECK')
  const residentReserve = passengerInventory?.reserves?.find((reserve) => reserve.reserveType === 'RESIDENT')
  const bicycleInventory = carDeck?.availableInventoryClasses.find((item) => item.inventoryClass === 'BICYCLE')
  const carDeckInventory = carDeck?.availableInventoryClasses.find((item) => item.inventoryClass === 'CAR_DECK')

  const passengerQty = passengerInventory?.amount
  const residentQty = residentReserve?.amount
  const bicycleQty = bicycleInventory?.amount
  const carDeckQty = carDeckInventory?.amount

  return {
    passengerQty,
    residentQty,
    bicycleQty,
    carDeckQty,
  }
}
